import { cn } from "@utils/tailwind.util";

interface FieldErrorMessageProps {
  message?: string;
  className?: string;
}

// The one inline error line, so a control's red border and its message can never disagree.
export function FieldErrorMessage({ message, className }: FieldErrorMessageProps) {
  if (!message) return null;

  return (
    <p
      className={cn(
        "mt-1.5 text-[13px] font-normal not-italic text-content-error dark:text-content-errorLight",
        className
      )}
    >
      {message}
    </p>
  );
}
